export default __webpack_public_path__ + "static/media/HRFrontRunner.bae048cf.png";